import * as React from 'react';

const Instagram = (props) => (
  <svg
    width={25}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.638 9.676A3.13 3.13 0 0 0 9.514 12.8a3.13 3.13 0 0 0 3.124 3.124 3.13 3.13 0 0 0 3.124-3.124 3.13 3.13 0 0 0-3.124-3.124Zm9.37 3.124c0-1.293.012-2.575-.06-3.867-.073-1.5-.416-2.831-1.512-3.928-1.1-1.1-2.429-1.44-3.929-1.512-1.293-.072-2.575-.06-3.867-.06-1.294 0-2.576-.012-3.867.06-1.5.073-2.831.415-3.928 1.512-1.1 1.1-1.44 2.428-1.512 3.928-.073 1.294-.06 2.576-.06 3.867 0 1.292-.013 2.576.06 3.867.073 1.5.415 2.832 1.512 3.929 1.1 1.099 2.428 1.439 3.928 1.511 1.294.073 2.576.061 3.867.061 1.294 0 2.576.012 3.867-.06 1.5-.073 2.832-.416 3.928-1.512 1.1-1.1 1.44-2.428 1.512-3.928.075-1.292.061-2.574.061-3.868Zm-9.37 4.807A4.8 4.8 0 0 1 7.83 12.8a4.8 4.8 0 0 1 4.807-4.807 4.8 4.8 0 0 1 4.807 4.807 4.8 4.8 0 0 1-4.807 4.807Zm5.004-8.688a1.121 1.121 0 0 1-1.123-1.123c0-.62.502-1.122 1.123-1.122a1.121 1.121 0 0 1 .43 2.16 1.122 1.122 0 0 1-.43.085Z"
      fill="#549A9A"
    />
  </svg>
);

export default Instagram;
